import R from 'ramda'

const MENTION_TRIGGER_TYPE = 'MENTION'
const MENTION_DISPLAY_TYPE = 'Match Handle'

const isMentionFormTrigger = R.propEq('type', MENTION_DISPLAY_TYPE)

const convertMentionFormTriggerToWidgetTrigger = R.applySpec({
  type: R.always(MENTION_TRIGGER_TYPE),
  data: R.prop('handles'),
  operator: R.always('AND'),
  primary: R.T
})

export { isMentionFormTrigger, convertMentionFormTriggerToWidgetTrigger }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/triggers/instagram/form-to-widget/mention.js